
import React, { useState, useEffect } from "react";
import { AiTwotoneCalendar, AiOutlineLeft, AiOutlineRight } from "react-icons/ai";
import { YouTubeEmbed } from "react-social-media-embed";
import { HiOutlineSparkles } from "react-icons/hi";
import PocketBase from "pocketbase";

export const Talents = () => {
  const [articles, setArticles] = useState([]);
  const [talents, setTalents] = useState([]);
  const [currentArticleIndex, setCurrentArticleIndex] = useState(0);
  const [talentCategories, setTalentCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const pb = new PocketBase(process.env.REACT_APP_POCKETBASE_URL);
        const categorieRecords = await pb.collection("TalentsCategories").getFullList();
        setTalentCategories(categorieRecords);

        const response = await pb.collection("Articles").getFullList();
        setArticles(response);

        const records = await pb.collection("Talents").getFullList();
        setTalents(records);
      } catch (error) {
        console.error("Error fetching articles:", error);
      }
    };
    fetchArticles();
  }, []);

  useEffect(() => {
    if (articles.length === 0) return;
    const interval = setInterval(() => {
      setCurrentArticleIndex((prevIndex) => (prevIndex + 1) % articles.length);
    }, 7000);
    return () => clearInterval(interval);
  }, [articles]);

  const handlePrev = () => {
    setCurrentArticleIndex((prevIndex) =>
      prevIndex === 0 ? articles.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentArticleIndex((prevIndex) =>
      (prevIndex + 1) % articles.length
    );
  };

  
  const filteredTalents = selectedCategory 
    ? talents.filter((item) => item.categorie === selectedCategory)
    : talents;

  return (
    <>
      <section className="courses bg-[#F3F4F8] py-12">
        <div className="w-4/5 m-auto md:w-11/12">
          <div className="heading text-center mb-8">
            <div className="relative mb-8">
              <div className="flex items-center justify-center">
                <HiOutlineSparkles className="text-4xl text-purple-500 mr-4" />
                <h1 className="text-3xl font-semibold text-black bg-gradient-to-r from-purple-500 to-blue-500 bg-clip-text text-transparent">
                  Article
                </h1>
              </div>
              <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-r from-purple-500 to-blue-500 rounded-full blur-xl opacity-30"></div>
            </div>
          </div>
          {articles.length > 0 ? (
            <div className="relative">
              <div className="article-card border rounded shadow-sm p-4 mb-4">
                <div 
                  className="article-content"
                  dangerouslySetInnerHTML={{ __html: articles[currentArticleIndex].conent }}
                />
              </div>
              <div className="flex justify-center mt-4 space-x-4">
                <button 
                  onClick={handlePrev} 
                  className="bg-purple-500 text-white px-4 py-2 rounded hover:bg-purple-600"
                  aria-label="Previous Article"
                >
                  <AiOutlineLeft />
                </button>
                <button 
                  onClick={handleNext} 
                  className="bg-purple-500 text-white px-4 py-2 rounded hover:bg-purple-600"
                  aria-label="Next Article"
                >
                  <AiOutlineRight />
                </button>
              </div>
            </div>
          ) : (
            <p className="text-center text-gray-600">No articles available.</p>
          )}
        </div>
      </section>

      <section className="courses bg-[#F3F4F8] py-12">
        <div className="w-4/5 m-auto md:w-11/12">
          <div className="heading text-center mb-8">
            <div className="relative mb-8">
              <div className="flex items-center justify-center">
                <HiOutlineSparkles className="text-4xl text-purple-500 mr-4" />
                <h1 className="text-3xl font-semibold text-black bg-gradient-to-r from-purple-500 to-blue-500 bg-clip-text text-transparent">
                  Talents
                </h1>
              </div>
              <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-r from-purple-500 to-blue-500 rounded-full blur-xl opacity-30"></div>
            </div>
            <div className="mb-6 w-full">
              <select
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
                className="p-2 rounded border w-64"
              >
                <option value="">All Categories</option>
                {talentCategories.map((category) => (
                  <option key={category.id} value={category.id}>
                    {category.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="grid grid-cols-3 gap-8 md:grid-cols-1">
            {filteredTalents.slice(0, 3).map((item) => (
              <div key={item.id} className="box rounded-lg shadow-lg bg-white overflow-hidden">
                <div className="video-container">
                  <YouTubeEmbed
                    url={item.link}
                    width="100%"
                    height="300px"
                    className="rounded-t-lg"
                  />
                </div>
                <div className="text p-4">
                  <span className="text-[12px] bg-blue-500 text-white p-1 px-3 rounded-[5px]">
                    {item.name}
                  </span>
                  <h3 className="text-black my-4 font-medium text-lg">{item.title}</h3>
                  <div className="user flex items-center justify-between mt-4">
                    <div className="flex items-center">
                      {/*
                      Uncomment and update if using host profile pictures
                      <img
                        className="rounded-full w-8 h-8 object-cover shadow-md"
                        src={item.hostProfilePicUrl}
                        alt="Host"
                      />
                      <span className="text-[14px] ml-3">{item.hostName}</span>
                      */}
                    </div>
                    <div className="flex items-center text-gray-600">
                      <AiTwotoneCalendar />
                      <span className="text-[14px] ml-2">{item.date}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};
